/**
 * @desc Directive that renders a custom donut chart
 * @example <cs-donut size="400" config="myCtrl.donutConfig"></cs-donut>
 *
 * config is an object that is an array of configurations, such as:
 * {
 *   data: [{idx: 0, val: 1, c: 'fill-blue'}, {idx: 2, val: 2, c: 'fill-green'}, {idx: 1, val: 4, c: 'fill-orange'}],
 *   valueAccessor: 'val',
 *   classAccessor: 'c',
 *   sort: 'idx',
 *   tooltipTemplate: '\'views/tooltips/donut/cs-donut-tooltip.html\''
 *  },{
 *    ...
 *  }]
 */
;(function () {
  'use strict'

  angular
    .module('contrast.donut')
    .directive('csDonut', [
      '$compile',
      'csDonutRenderService',
      'csDonutConfigService',
      'CS_DONUT_CONSTANTS',
      csDonut
    ])

  function csDonut(
    $compile,
    csDonutRenderService,
    csDonutConfigService,
    CS_DONUT_CONSTANTS
  ) {
    return {
      restrict: 'E',
      replace: true,
      transclude: true,
      scope: {
        size: '=',
        config: '=',
        onItemClick: '&'
      },
      templateUrl: 'views/cs-donut.html',
      link: link
    }

    function link($scope, element) {
      var selectors
      var size = $scope.size || CS_DONUT_CONSTANTS.DEFAULT_SIZE
      var chartElement = element.find(CS_DONUT_CONSTANTS.CHART_SELECTOR)
      var config = {
        chartElement: chartElement[0],
        size: size,
        onItemClick: $scope.onItemClick()
      }

      selectors = _renderChart($scope, config)

      $scope.$watch('config', function (newValue, oldValue) {
        if (angular.isDefined(newValue) && newValue !== oldValue) {
          selectors = _renderChart($scope, config, selectors)
        }
      })
    }

    function _renderChart($scope, config, selectors) {
      config.data = []

      if (angular.isArray($scope.config)) {
        for (var i = 0; i < $scope.config.length; i++) {
          config.data.push(csDonutConfigService.createConfig($scope.config[i]))
        }
      }

      if (config.data.length > 0) {
        selectors = csDonutRenderService.render(
          config,
          selectors,
          _getCompileFn($scope)
        )
      }
      return selectors
    }

    function _getCompileFn($scope) {
      return function (element) {
        $compile(element)($scope)
      }
    }
  }
})()
